import { useEffect } from "react";
import { createContext, useState } from "react";
import { useSelector } from "react-redux";
import { getPolicies } from "service/agent/getPolicies";

export const AgentData = createContext();

export default function DataProvider({ children }) {
  const { user } = useSelector((state) => state.user);

  // Default
  const [agentData, setAgentData] = useState({
    agentPolicies: [],
    filteredPolicies: [],
    agentClaims: [],
  });

  const [isAgentPoliciesLoading, setIsAgentPoliciesLoading] = useState(true);

  useEffect(() => {
    let policyIds = [];
    for (let i = 0; i < user?.agentHierarchy?.length; i++) {
      if (user?.agentHierarchy[i]?.policyIds)
        policyIds.push(...user?.agentHierarchy[i].policyIds);
    }
    if (policyIds?.length > 0 && agentData?.agentPolicies?.length === 0) {
      getPolicies(policyIds)
        .then((response) => {
          setAgentData({
            agentPolicies: response?.agentPolicies,
            filteredPolicies: response?.filteredPolicies,
            agentClaims: response?.agentClaims,
          });
          setIsAgentPoliciesLoading(false);
        })
        .catch((error) => {
          setIsAgentPoliciesLoading(false);
          console.error(error);
        });
    }
  }, [user?.userId]);

  return (
    <AgentData.Provider
      value={{
        ...agentData,
        setAgentData,
        isAgentPoliciesLoading,
        setIsAgentPoliciesLoading,
      }}
    >
      {children}
    </AgentData.Provider>
  );
}
